/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Change_OnlyInputs */

const en_orders_change_only = /** @type {(inputs: Orders_Change_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Only`)
};

const es_orders_change_only = /** @type {(inputs: Orders_Change_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar solamente`)
};

/**
* | output |
* | --- |
* | "Change Only" |
*
* @param {Orders_Change_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_change_only = /** @type {((inputs?: Orders_Change_OnlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Change_OnlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_change_only(inputs)
	return es_orders_change_only(inputs)
});